import request from '@/utils/login-request'

export function newlogin(username, password) {
  return request({
    url: '/login',
    method: 'post',
    data: {
      username: username,
      password: password
    }
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: '/user/get/getuserAndAction',
    method: 'get'
  })
}

// 获取业务系统树形菜单
export function bussinessTree(reqParams) {
  return request({
    url: `/usermenu/get/bussinesstree/${reqParams}`,
    method: 'get'
    // params: reqParams
  })
}
// 模糊查询 根据用户名获取用户列表
export function getUserInfoByName(params) {
  return request({
    url: '/user/get/list',
    method: 'get',
    params: { ...params }
  })
}
// 根据用户id获取用户信息
export function getUserInfoById(userId) {
  return request({
    url: `/user/get/${userId}`,
    method: 'get'
    // params:params
  })
}
// 根据用户id集合获取用户信息
export function getUserInfoByIdList(params) {
  return request({
    url: `/user/get/users`,
    method: 'post',
    data: {
      noDeleted: true,
      ...params
    }
  })
}
// 根据用户id查询公司信息
export function getCompanyInfo(param) {
  return request({
    url: `/user/get/company-info`,
    method: 'get',
    params: param
  })
}
// 根据条件模糊查询用户
export function getUserPage(param) {
  return request({
    url: `/user/get/list`,
    method: 'get',
    params: param
  })
}
// 根据条件模糊查询用户
export function getSystemList(param) {
  return request({
    url: `/userSystemMap/get/userId/forlogin`,
    method: 'get',
    params: param
  })
}
// 查询所有葫芦
export function getSmaOrgConfig(params) {
  return request({
    url: `/smaOrgConfig/get`,
    method: 'get',
    params: params
  })
}
// 查询所有评分人群
export function getDepartment(params) {
  return request({
    url: `/department/get/1030/tree`, // 线上
    // url: `/department/get/215/tree`, // 测试
    method: 'get',
    params: params
  })
}
